import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { setting } from '../../../../../setting';
import { map, takeUntil } from 'rxjs/operators';

@Injectable()
export class AddressesService {

  private endpoint: string;
  private endpointLocationsAll: string = '';
  private url = setting.apiOctopusUrl;
  private urlDev = setting.apiOctopusUrl;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {
   // this.endpoint = this.url + '/address';
    //  this.endpoint = this.url + '/searchaddress';
     this.endpoint = this.url + '/utilities/getLocationTransfer';
     this.endpointLocationsAll = `${this.urlDev}/utilities/searchlocations/`
  }

  getAddress(iataCode: any, keyword: any, categoryId: any): Observable<any[]> {
    if (keyword.length > 1) {
      const url = this.endpoint + '/' + keyword + '/' + categoryId + '/' + iataCode;
      return this.http.get(url, { headers: this._headers })
        .map((res:any) => {
          const json = res.data;
          return json;
        });
    } else {
      return Observable.of([]);
    }
  }

  getLocationsAll(keyword: string, country?: any, pointToPoint?: boolean, category?: string): Observable<any[]> {
    if (keyword.length > 2) {
      let url: string = '';

      if(country && category === 'TRANSFERS') {
        if(pointToPoint) {
          url = `${this.endpointLocationsAll}${keyword}?country=${country}?address=true`;
        } else {
          url = `${this.endpointLocationsAll}${keyword}?country=${country}`;

        }
      } else {

        // if(pointToPoint) {
        //   url = `${this.endpointLocationsAll}${keyword}?address=true`;
        // } else {
          if(category === 'RENTCAR' || category === 'CRUISES') {
              url = `${this.endpointLocationsAll}${keyword}?category=${category}&limit=15`; // ver el limit por categoría;
          } else {
              url = `${this.endpointLocationsAll}${keyword}?category=${category}`;
          }

        // }
      }

      return this.http.get<any>(url, { headers: this._headers }).pipe(
        takeUntil(this._unsubscribeAll),
        map((res: any) => {

          const mergedArray = [
            {
              airports: res.airports,
              type: 'airport',
            },
            {
                cities: category === 'TRANSFERS' ? res.addressGoogle : res.cities,
                type: 'city',
            },
            {
                hotels: res.hotels,
                type: 'hotel',
            },
            {
              ports: res.ports,
              type: 'port',
            },
            {
                trains: res.trains,
                type: 'train',
            },
            {
                buses: res.buses,
                type: 'bus',
            },
            {
              restaurants: res.restaurants,
              type: 'restaurant',
            },
            {
                attractions: res.attractions,
                type: 'attraction',
            }

          ];
          return mergedArray;
        })
      );
    } else {
      return of([]); // Retorna un array vacío si no hay keyword
    }
  }



  _getAddress(iataCode: any, keyword: any, categoryId: any, type: any): Observable<any[]> {
    if (keyword) {
      const url = this.endpoint + '/' + keyword + '/' + categoryId + '/' + iataCode;
      return this.http.get(url, { headers: this._headers })
      .map((res:any) => {
        const json = res.data;
          if (type) {
            const resu = json.filter(d => d.type !== type);
            return resu;
          } else {
            return json;
         }
        });
    } else {
      return Observable.of([]);
    }
  }

  _getLocations(iataCode:string):Observable<any[]>{
    if (iataCode) {
      const url = this.endpoint + '/' + iataCode + '/' + "HOTEL";
      console.log('url locations', url);
      return this.http.get(url)
      .map((res:any) => {
        console.log('res nuevo endpoint transfer', res);
        const json = res;
          return json;
        });
    } else {
      return Observable.of([]);
    }
  }


  private get _headers() {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('client-id', environment.client_id);
    headers.append('client-secret', environment.client_secret);
    if (localStorage.getItem('bearer')) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('bearer'));
    }
    return headers;
  }
}
